"use client";

import { useIsTouchDevice } from "@/components/ui/hooks/use-mobile";
import type { CategoryTreeItems } from "@/lib/categories";
import { YnsLink } from "@/ui/yns-link";
import { useState } from "react";

export function CategoryMenuInner({
	transformedCategories,
}: {
	transformedCategories: CategoryTreeItems;
}) {
	const isTouchDevice = useIsTouchDevice();
	const [openItem, setOpenItem] = useState<string | null>(null);

	return (
		<ul className="flex flex-row flex-wrap text-sm font-medium gap-x-8 items-center justify-start md:text-black">
			{transformedCategories.map((category) => (
				<li key={category.id} className="relative group">
					<YnsLink
						href={`/category/${category.slug}`}
						className="font-normal py-2 block text-(--theme-category-menu-color) hover:text-(--theme-category-menu-hover-background-color) rounded-md transition-colors"
						aria-expanded={openItem === category.id}
						onClick={(e) => {
							// On touch devices, opening a top-level link requires two taps because submenu opens first
							if (!isTouchDevice || !category.children.length || openItem === category.id) {
								// continue to link
								setOpenItem(null);
								return;
							}

							setOpenItem(category.id);
							e.preventDefault();
						}}
					>
						{category.name}
					</YnsLink>

					{category.children.length > 0 && (
						<ul className="absolute z-40 shadow-lg rounded-md bg-(--theme-category-menu-background-color) flex-col gap-y-2 hidden group-focus-within:flex group-hover:flex">
							{category.children.map((subCategory) => (
								<li key={subCategory.id}>
									<YnsLink
										href={`/category/${category.slug}/${subCategory.slug}`}
										className="font-normal px-4 py-2 block text-(--theme-category-menu-color) hover:text-(--theme-category-menu-hover-background-color) rounded-md transition-colors"
									>
										{subCategory.name}
									</YnsLink>
								</li>
							))}
						</ul>
					)}
				</li>
			))}
		</ul>
	);
}
